module.exports = __webpack_public_path__ + "static/deposition-1-b0b683588948146b418d3259627a57e1.png";